export function VisibleOffIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2407_94458)">
        <path
          d="M14.9497 14.9502C13.5252 16.036 11.7906 16.6376 9.99967 16.6668C4.16634 16.6668 0.833008 10.0002 0.833008 10.0002C1.86958 8.06843 3.30729 6.38069 5.04967 5.05018M8.24967 3.53352C8.82328 3.39925 9.41056 3.33213 9.99967 3.33352C15.833 3.33352 19.1663 10.0002 19.1663 10.0002C18.6605 10.9465 18.0572 11.8375 17.3663 12.6585M11.7663 11.7668C11.5375 12.0125 11.2615 12.2095 10.9548 12.3461C10.6481 12.4828 10.3171 12.5562 9.98142 12.5622C9.64574 12.5681 9.31231 12.5063 9.00102 12.3806C8.68972 12.2549 8.40694 12.0677 8.16955 11.8303C7.93215 11.5929 7.745 11.3101 7.61927 10.9988C7.49353 10.6875 7.43178 10.3541 7.4377 10.0184C7.44363 9.68277 7.5171 9.35172 7.65374 9.04506C7.79038 8.73839 7.98739 8.46239 8.23301 8.23352"
          stroke="#A0A1A6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.833008 0.833496L19.1663 19.1668"
          stroke="#A0A1A6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2407_94458">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
